import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage: sesi dibagi antar tab (FE #70)
import encryptTransform from '../utils/encryptTransform';
import decryptTransform from '../utils/decryptTransform';

// Import semua reducers Anda seperti sebelumnya
import LayoutReducer from './layouts/reducer';
import LoginReducer from './auth/login/reducer';
import AccountReducer from './auth/register/reducer';
import ProfileReducer from './auth/profile/reducer';
import CalendarReducer from './calendar/reducer';
import chatReducer from './chat/reducer';
import EcommerceReducer from './ecommerce/reducer';
import ProjectsReducer from './projects/reducer';
import TasksReducer from './tasks/reducer';
import CryptoReducer from './crypto/reducer';
import TicketsReducer from './tickets/reducer';
import CrmReducer from './crm/reducer';
import InvoiceReducer from './invoice/reducer';
import MailboxReducer from './mailbox/reducer';
import DashboardAnalyticsReducer from './dashboardAnalytics/reducer';
import DashboardCRMReducer from './dashboardCRM/reducer';
import DashboardEcommerceReducer from './dashboardEcommerce/reducer';
import DashboardCryptoReducer from './dashboardCrypto/reducer';
import DashboardProjectReducer from './dashboardProject/reducer';
import DashboardNFTReducer from './dashboardNFT/reducer';
import DashboardProcurementReducer from './dashboardProcurement/reducer';
import TeamDataReducer from './team/reducer';
import FileManagerReducer from './fileManager/reducer';
import TodosReducer from './todos/reducer';
import JobReducer from './jobs/reducer';
import APIKeyReducer from './apiKey/reducer';

// Gabungkan semua reducer Anda
const appReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  Profile: ProfileReducer,
  Calendar: CalendarReducer,
  Chat: chatReducer,
  Projects: ProjectsReducer,
  Ecommerce: EcommerceReducer,
  Tasks: TasksReducer,
  Crypto: CryptoReducer,
  Tickets: TicketsReducer,
  Crm: CrmReducer,
  Invoice: InvoiceReducer,
  Mailbox: MailboxReducer,
  DashboardAnalytics: DashboardAnalyticsReducer,
  DashboardCRM: DashboardCRMReducer,
  DashboardEcommerce: DashboardEcommerceReducer,
  DashboardCrypto: DashboardCryptoReducer,
  DashboardProject: DashboardProjectReducer,
  DashboardNFT: DashboardNFTReducer,
  DashboardProcurement: DashboardProcurementReducer,
  Team: TeamDataReducer,
  FileManager: FileManagerReducer,
  Todos: TodosReducer,
  Jobs: JobReducer,
  APIKey: APIKeyReducer,
});

// Konfigurasi redux-persist
const persistConfig = {
  key: 'root',
  storage, // localStorage — semua tab = 1 sesi; logout/idle berlaku serentak
  whitelist: ['Login', 'Account', 'Profile'],
  transforms: [encryptTransform, decryptTransform], // Simpan hanya reducer Login, bisa tambah lain jika perlu
};

// Bungkus root reducer dengan persistReducer
const rootReducer = persistReducer(persistConfig, appReducer);

export default rootReducer;
